const Immutable = require('seamless-immutable');
const { did, doing } = require('./common');
const {
	FETCHED_GRADE_LEVELS,
	FETCHING_GRADE_LEVELS
} = require('../actions/gradeLevels');

const baseState = Immutable({
	list: [],
	isFetching: false
});

const gradeLevels = function(state = baseState, action) {
	switch (action.type) {
		case FETCHING_GRADE_LEVELS:
			state = doing('isFetching', state);
			break;
		case FETCHED_GRADE_LEVELS:
			state = did('isFetching', state, action);
			break;
	}
	return state;
};

module.exports = gradeLevels;



// WEBPACK FOOTER //
// ./frontend/a2i/js/reducers/gradeLevels.js